import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}
  transform(
    money: number,
    showFt: boolean = true,
    showPrecisions: boolean = true
  ) {
    return this.currencyPipe.transform(
      money,
      'HUF',
      showFt ? 'symbol' : '',
      showPrecisions ? '.2-2' : '.0'
    );
  }
}
